import { useMatchesMediaQuery } from './useMatchesMediaQuery';

export const useIsDesktop = () => {
  return useMatchesMediaQuery({
    query: `(min-width: 1024px)`,
  });
};
